import accountClosureStatement from '../../../assets/files/ru/Заявление_о_закрытии_счета.pdf';
import accountClosureStatementArchive from '../../../assets/files/ru/Заявление_о_закрытии_счета_архив.pdf';
import applicationForAmendmentsToTheAgreementOnOpeningAndMaintainingAnAccount from '../../../assets/files/ru/Заявление_о_внесении_изменений_в_договор_об_открытии_и_ведении_счета.pdf';
import applicationForAmendmentsToTheAgreementOnOpeningAndMaintainingAnAccountArchive from '../../../assets/files/ru/Заявление_о_внесении_изменений_в_договор_об_открытии_и_ведении_счета_архив.pdf';
import applicationForOpeningACardAccount from '../../../assets/files/ru/application_for_opening_an_account_for_card_settlements_and_issuance_of_a_bank_card.pdf';
import applicationForOpeningACardAccountArchive from '../../../assets/files/ru/application_for_opening_an_account_for_card_settlements_and_issuance_of_a_bank_card_archive.pdf';
import applicationForOpeningAndMaintainingAnAccount from '../../../assets/files/ru/application_for_account_opening_and_maintenance.pdf';
import applicationForOpeningAndMaintainingAnAccountArchive from '../../../assets/files/ru/application_for_account_opening_and_maintenance_archive.pdf';
import applicationToCloseACardAccount from '../../../assets/files/ru/Заявление_на_закрытие_карточного_счета.pdf';
import applicationToCloseACardAccountArchive from '../../../assets/files/ru/Заявление_на_закрытие_карточного_счета_архив.pdf';
import booklet from '../../../assets/files/ru/Справочник_вкладчика.pdf';
import certificate from '../../../assets/files/ru/Вх._корр._от_Государственная_корпорация_Агентство_по_страхованию_вкладов_№2024-00291_от_29._(13662v2).pdf';
import conditionsForOpeningDeposit from '../../../assets/files/ru/usloviya_otkrytiya_vklada_fl.pdf';
import conditionsForOpeningDepositArchive from '../../../assets/files/ru/usloviya_otkrytiya_vklada_fl_archive.pdf';
import debitCardPassport from '../../../assets/files/ru/debit_card_passport.pdf';
import depositPassport from '../../../assets/files/ru/passport_vklada.pdf';
import depositPremiumPassport from '../../../assets/files/ru/passport_premium_vklada.pdf';
import depositSavingsPassport from '../../../assets/files/ru/pasport_savings_vklada.pdf';
import depositAnythingGoesPassport from '../../../assets/files/ru/passport_vklada_anything_goes.pdf'
import digitalCardPassport from '../../../assets/files/ru/digital_card_passport.pdf';
import individualAccountOpeningConditions from '../../../assets/files/ru/conditions_for_opening_maintaining_and_closing_bank_accounts_for_individuals.pdf';
import individualAccountOpeningConditionsArchive from '../../../assets/files/ru/conditions_for_opening_maintaining_and_closing_bank_accounts_for_individuals_archive.pdf';
import operationsControlAgreement from '../../../assets/files/ru/terms_of_service_for_operation_control_in_bank_131.pdf';
import operationsControlAgreementArchive from '../../../assets/files/ru/terms_of_service_for_operation_control_in_bank_131_archive.pdf';
import passportCurrentAccount from '../../../assets/files/ru/passport_current_account.pdf';
import rulesForComprehensiveBankingServicesForIndividuals from '../../../assets/files/ru/rules_for_comprehensive_banking_services_for_individuals.pdf';
import rulesForComprehensiveBankingServicesForIndividualsArchive from '../../../assets/files/ru/rules_for_comprehensive_banking_services_for_individuals_archive.pdf';
import salaryCardPassport from '../../../assets/files/ru/salary_card_passport.pdf';
import savingsAccountPlan from '../../../assets/files/ru/savings_account_plan.pdf';
import termsOfServiceAndUseOfJSCBankCard131 from '../../../assets/files/ru/terms_of_service_and_use_of_the_bank_card_of_bank_131.pdf';
import termsConditionsoftheCardholderLoyaltyProgramOfJSCBankCard131 from '../../../assets/files/ru/terms_conditions_of_the_cardholder_loyalty_program_of_bank_card_131.pdf';
import termsOfServiceAndUseOfJSCBankCard131Archive from '../../../assets/files/ru/terms_of_service_and_use_of_the_bank_card_of_bank_131_archive.pdf';
import termsOfMedicalBankingServicesForIndividualsAtAOBank131Archive from '../../../assets/files/ru/terms_of_medical_banking_services_for_individuals_at_bank_131_archive.pdf'

import zayavlenieNaOtkrytieVklada from '../../../assets/files/ru/Заявление_о_размещении_вклада.pdf';
import zayavlenieNaOtkrytieVkladaArchive from '../../../assets/files/ru/Заявление_о_размещении_вклада_архив.pdf';
import zayavlenieNaZakrytieVklada from '../../../assets/files/ru/Заявление_закрытие_вклада.pdf';
import zayavlenieNaZakrytieVkladaArchive from '../../../assets/files/ru/Заявление_закрытие_вклада_архив.pdf';

export default {
  seo: {
    title: "Страхование вкладов | Банк 131",
    description: "Страхование вкладов",
  },
  title: "Страхование вкладов",
  content: [
    {
      text: `<p>АО «Банк 131» является участником системы обязательного страхования вкладов.</p><ul><li><p><a href=${certificate} target="_blank">Свидетельство о включении АО «Банк 131»  в реестр банков – участников системы обязательного страхования вкладов</a></p></li><li><p>Федеральный закон <a href="https://www.cbr.ru/banking_sector/acts/177-fz/" target="_blank">«О страховании вкладов в банках Российской Федерации»</a></p></li><li><p><a href=${booklet} target="_blank">Справочник вкладчика</a></p></li></ul><p>С подробной информацией о вкладах, подлежащих страхованию в соответствии с указанным федеральным законом, о размере возмещения по вкладам, описанием порядка обращения вкладчика в ГК «АСВ» с требованием о выплате возмещения по вкладам, порядком выплаты возмещения по вкладам, информацией о праве вкладчика на получение оставшейся после выплаты возмещения части вклада, а также с <a href="https://www.asv.org.ru/support" target="_blank">ответами на вопросы</a> о системе страхования вкладов вы можете ознакомиться на сайте ГК «АСВ» (<a href="https://www.asv.org.ru/" target="_blank">www.asv.org.ru</a>)</p><br/><h4>Реквизиты ГК «АСВ»:</h4><p>Полное наименование: Государственная корпорация «Агентство по страхованию вкладов»</p><p>Адрес: 109240, г. Москва, ул. Высоцкого, д. 4 </p><p>Адрес электронной почты: <a href="mailto:info@asv.org.ru">info@asv.org.ru</a></p><p>Телефон горячей линии: 8 800 200-08-05 (бесплатный звонок по России) </p><p>Адрес официального сайта Агентства в сети «Интернет»: <a href="https://www.asv.org.ru/" target="_blank">https://www.asv.org.ru</a></p>`,
    },
    {
      title: "Физическим лицам",
      items: [
        {
          title: "Правила комплексного банковского обслуживания",
          link: rulesForComprehensiveBankingServicesForIndividuals,
        }
      ],
    },
    {
      title: "Тарифы",
      items: [
        {
          title: "Тарифы обслуживания физических лиц в АО «Банк 131»",
          link: '/documents/ru/tariffs_for_individuals.pdf',
        },
        {
          title: "Тарифный план: Накопительный счет",
          link: savingsAccountPlan,
        },
      ],
    },
    {
      title: "Вклады",
      items: [
        {
          title: "Паспорт продукта «Вклад 131»",
          link: depositPassport,
        },
        {
          title: "Паспорт продукта «Вклад 131 - Премиум»",
          link: depositPremiumPassport,
        },
        {
          title: "Паспорт продукта «Накопительный счет»",
          link: depositSavingsPassport,
        },
        {
          title: "Паспорт продукта «Вклад Можно все»",
          link: depositAnythingGoesPassport,
        },
        {
          title:
            "Условия открытия, обслуживания и закрытия банковских вкладов физических лиц в АО «Банк 131»",
          link: conditionsForOpeningDeposit,
        },
        {
          title: "Заявление о размещении вклада",
          link: zayavlenieNaOtkrytieVklada,
        },
        {
          title: "Заявление о закрытии вклада",
          link: zayavlenieNaZakrytieVklada,
        },
      ],
    },
    {
      title: "Счета",
      items: [
        {
          title: 'Паспорт продукта «Текущий счет»',
          link: passportCurrentAccount,
        },
        {
          title:
            "Условия открытия, ведения и закрытия банковских счетов физических лиц в АО «Банк 131»",
          link: individualAccountOpeningConditions,
        },
        {
          title: "Заявление о заключении договора",
          link: applicationForOpeningAndMaintainingAnAccount,
        },
        {
          title: "Заявление о внесении изменений",
          link: applicationForAmendmentsToTheAgreementOnOpeningAndMaintainingAnAccount,
        },
        {
          title: "Заявление о закрытии счета",
          link: accountClosureStatement,
        },
      ],
    },
    {
      title: "Карты",
      items: [
        {
          title:
            "Условия Программы лояльности держателей Карт АО «Банк 131»",
          link: termsConditionsoftheCardholderLoyaltyProgramOfJSCBankCard131,
        },
        {
          title:
            "Условия обслуживания и пользования банковской картой АО «Банк 131»",
          link: termsOfServiceAndUseOfJSCBankCard131,
        },
        {
          title:
            "Заявление на открытие счета, служащего для расчетов по карте, и выпуск банковской карты",
          link: applicationForOpeningACardAccount,
        },
        {
          title:
            "Заявление на закрытие карточного счета",
          link: applicationToCloseACardAccount,
        },
        {
          title:
            'Паспорт "131 Дебетовая карта"',
          link: debitCardPassport,
        },
        {
          title:
            'Паспорт "131 Зарплатная карта"',
          link: salaryCardPassport,
        },
        {
          title:
            'Паспорт "131 Цифровая карта"',
          link: digitalCardPassport,
        },
      ],
    },
    {
      title: "Дистанционное банковское обслуживание физических лиц",
      items: [
        {
          title:
            "Условия дистанционного банковского обслуживания физических лиц в АО «Банк 131»",
          link: '/documents/ru/terms_of_banking_services_for_individuals.pdf',
        },
        {
          title:
            "Пользовательское соглашение",
          link: '/legal/ru/user_agreement_for_bank_131_online_for_individuals.pdf', // TODO: ВАЖНО - ссылка используется в ДБО ФИЗ. ЛИЦ при первой авторизациии в чекбоксе 
        },
      ],
    },
    {
      title: 'Сервис «Контроль операций» по банковским счетам (вкладам) физического лица',
      items: [
        {
          title:
            "Условия оказания услуги «Контроль операций» в АО «Банк 131»",
          link: operationsControlAgreement,
        },
      ],
    },
    {
      title: 'Архив',
      items: [
        {
          label: 'Версия 1 от 08.12.2025',
          title: 'Заявление на открытие карточного счета (к Приложению 3)',
          link: applicationForOpeningACardAccountArchive,
        },
        {
          label: 'Версия 1 от 08.12.2025',
          title: 'Заявление об открытии и ведении счета (к Приложению 1)',
          link: applicationForOpeningAndMaintainingAnAccountArchive,
        },
        {
          label: 'Версия 1 от 08.12.2025',
          title: 'Заявление о внесении изменений (к Приложению 1).',
          link: applicationForAmendmentsToTheAgreementOnOpeningAndMaintainingAnAccountArchive,
        },
        {
          label: 'Версия 1 от 08.12.2025',
          title: 'Заявление о закрытии вклада (к Приложению 2)',
          link: zayavlenieNaZakrytieVkladaArchive,
        },
        {
          label: 'Версия 1 от 08.12.2025',
          title: 'Заявление о закрытии счета (к Приложению 1)',
          link: accountClosureStatementArchive,
        },
        {
          label: 'Версия 1 от 08.12.2025',
          title: 'Заявление о размещении вклада (к Приложению 2)',
          link: zayavlenieNaOtkrytieVkladaArchive,
        },
        {
          label: 'Версия 1 от 08.12.2025',
          title: 'Заявление о расторжении договора (к Приложению 3)',
          link: applicationToCloseACardAccountArchive,
        },
        {
          label: 'Версия 1 от 08.12.2025',
          title: "Правила комплексного банковского обслуживания физических лиц",
          link: rulesForComprehensiveBankingServicesForIndividualsArchive,
        },
        {
          label: 'Версия 1 от 08.12.2025',
          title: "Условия дистанционного банковского обслуживания (Приложение 4)",
          link: termsOfMedicalBankingServicesForIndividualsAtAOBank131Archive,
        },
        {
          label: 'Версия 1 от 08.12.2025',
          title: "Условия обслуживания и пользования банковской картой (Приложение 3)",
          link: termsOfServiceAndUseOfJSCBankCard131Archive,
        },
        {
          label: 'Версия 1 от 08.12.2025',
          title: 'Условия оказания услуги Контроль операций (к Приложению 4)',
          link: operationsControlAgreementArchive,
        },
        {
          label: 'Версия 1 от 08.12.2025',
          title: "Условия открытия, ведения и закрытия банковских счетов физических лиц (Приложение 1)",
          link: individualAccountOpeningConditionsArchive,
        },
        {
          label: 'Версия 1 от 08.12.2025',
          title: "Условия открытия, обслуживания и закрытия банковских вкладов (Приложение 2)",
          link: conditionsForOpeningDepositArchive,
        },
      ],
    },
  ],
};
